import { render } from "./ResourceFilter.vue?vue&type=template&id=b71c87da"
import script from "./ResourceFilter.vue?vue&type=script&lang=js"
export * from "./ResourceFilter.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__